/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

const PREFIX = 'StubLayer';

export const stubLayerClasses = {
  gradient: `${PREFIX}-gradient`,
  content: `${PREFIX}-content`,
  heading: `${PREFIX}-heading`,
  text: `${PREFIX}-text`,
  arrowHint: `${PREFIX}-arrowHint`,
};

export const StubLayerRoot = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '100%',
  minHeight: theme.spacing(35),
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,

  [`& .${stubLayerClasses.gradient}`]: {
    flex: 1,
    borderRadius: '100px',
    background: `linear-gradient(135deg, ${theme.palette.semantic_dark?.surface.surface1} 0%, ${theme.palette.semantic_dark?.surface.surface2} 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(0.5, 0),
  },

  [`& .${stubLayerClasses.content}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(4, 9),
    maxWidth: theme.spacing(100),
    width: '100%',
  },

  [`& .${stubLayerClasses.heading}`]: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    color: theme.palette.semantic_dark?.surface.onSurfaceLight,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },

  [`& .${stubLayerClasses.text}`]: {
    fontSize: '12px',
    lineHeight: '14px',
    color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  },

  [`& .${stubLayerClasses.arrowHint}`]: {
    fontSize: '12px',
    lineHeight: '14px',
    color: theme.palette.semantic_dark?.surface.onSurfaceLight,
    display: 'flex',
    alignItems: 'center',
  },
}));
